var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _ellipse, _ellipse2, _ellipse3, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _ellipse4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 46.288,
    height: 65.999,
    viewBox: "0 0 46.288 65.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{fill:url(#b);}.c{fill:url(#c);}.d{fill:url(#d);}.e{fill:url(#e);}.f{fill:url(#f);}.g{fill:url(#g);}.h{fill:url(#h);}.i{fill:url(#i);}.j{fill:url(#j);}.k{fill:url(#k);}.l{fill:url(#l);}.m{fill:url(#m);}.n{fill:url(#o);}.o{fill:url(#q);}.p{fill:url(#r);}.q{fill:url(#s);}.r{fill:url(#t);}.s{fill:url(#u);}.t{fill:url(#v);}.u{fill:url(#w);}.v{fill:url(#x);}.w{fill:url(#y);}.x{fill:url(#z);}.y{fill:url(#aa);}.z{fill:url(#ab);}.aa{fill:url(#ac);}.ab{fill:url(#ad);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.22,
    y1: 0.327,
    x2: 1,
    y2: 1.175,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4a98f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.531,
    y1: 0.727,
    x2: 0.496,
    y2: 0.316,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0469bc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0469bc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -0.906,
    y1: 0.315,
    x2: 3.315,
    y2: 0.871,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: -1.212,
    y1: 0.288,
    x2: 3.687,
    y2: 0.932,
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 0.414,
    y1: 0.448,
    x2: -1.271,
    y2: -0.064,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18cffc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65e1dc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 0.5,
    y1: 0.745,
    x2: 0.5,
    y2: -1.093,
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    y1: 1.551,
    x2: 0.5,
    y2: 0.509,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.289,
    stopColor: "#c8b7e0",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.591,
    stopColor: "#a595c8",
    stopOpacity: 0.592
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#8f81b8",
    stopOpacity: 0.839
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 0.5,
    y1: 0.745,
    x2: 0.5,
    y2: 0.245,
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa425"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: 0.724,
    y1: 0.573,
    x2: 1.081,
    y2: 0.688,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.519,
    stopColor: "#d9874f",
    stopOpacity: 0.518
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "k",
    x1: 0.442,
    y1: 0.408,
    x2: 0.941,
    y2: 1.199,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: 0.474,
    y1: 0.656,
    x2: 0.391,
    y2: 1.148,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.064,
    y1: 0.681,
    x2: -0.596,
    y2: 0.956,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -2.716,
    x2: -1.716,
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: 1.053,
    y1: 1.071,
    x2: -0.198,
    y2: -0.047,
    xlinkHref: "#j"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: 0.306,
    y1: 0.37,
    x2: 1.063,
    y2: 1.198,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcb37e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: 0.379,
    y1: 0.112,
    x2: 1.322,
    y2: 2.171,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fcb37e",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff7044"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: 0,
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -0.249,
    y1: 0.133,
    x2: 1.537,
    y2: 1.592,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -0.273,
    y1: 0.52,
    x2: 2.023,
    y2: 0.463,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "w",
    x1: 0.744,
    y1: 1.212,
    x2: 0.181,
    y2: -0.716,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "x",
    x1: 0.452,
    y1: 0.194,
    x2: 0.669,
    y2: 2.258,
    xlinkHref: "#r"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: 1.125,
    y1: 0.639,
    x2: -2.892,
    y2: 0.132,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "z",
    x1: 0.381,
    y1: 0.219,
    x2: 2.452,
    y2: 1.347,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 0.653,
    y1: 0.179,
    x2: -0.636,
    y2: 2.69,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ab",
    x1: 0.42,
    y1: 0.832,
    x2: 0.867,
    y2: -1.798,
    xlinkHref: "#s"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ac",
    x1: 0.516,
    y1: 0.569,
    x2: 0.255,
    y2: 0.171,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffee83"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ad",
    x1: 0.466,
    y1: 0.447,
    x2: 0.098,
    y2: -0.123,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda45",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcee21"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M150.7,223.744a15.605,15.605,0,0,0-15.441,15.664v20.6a.777.777,0,0,0,1.221.638l12.806-8.922a2.57,2.57,0,0,1,2.938,0l12.806,8.922a.777.777,0,0,0,1.221-.638V239.24a15.5,15.5,0,0,0-15.551-15.5Z",
    transform: "translate(-127.607 -194.789)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M168.892,260.01V239.24a15.48,15.48,0,0,0-30.6-3.338l.043.192,15.174,15.174a2.565,2.565,0,0,1,1.355.457l12.806,8.923A.777.777,0,0,0,168.892,260.01Z",
    transform: "translate(-130.252 -194.789)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M163.993,245.789V276.1l-3.3,2.3V248.963a15.651,15.651,0,0,1,3.3-3.172Z",
    transform: "translate(-149.753 -213.981)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M327.1,248.618v29.514l-3.3-2.3V245.484a15.584,15.584,0,0,1,3.3,3.134Z",
    transform: "translate(-291.755 -213.716)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M255,223.749v27.519a2.566,2.566,0,0,1,1.469.461l12.806,8.922a.777.777,0,0,0,1.221-.637v-20.77A15.5,15.5,0,0,0,255,223.749Z",
    transform: "translate(-231.856 -194.793)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M165.027,426.374l-12.806-8.922a2.57,2.57,0,0,0-2.938,0l-12.806,8.922a.777.777,0,0,1-1.221-.637v2.512a.777.777,0,0,0,1.221.637l12.806-8.922a2.57,2.57,0,0,1,2.938,0l12.806,8.922a.777.777,0,0,0,1.221-.637v-2.512A.777.777,0,0,1,165.027,426.374Z",
    transform: "translate(-127.608 -363.027)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M163.993,245.784v15.655l-3.3-3.3v-9.18c.066-.084.133-.168.2-.252s.145-.178.218-.264l.181-.212c.124-.141.249-.28.377-.416.046-.05.093-.1.141-.147.124-.13.251-.257.38-.381s.254-.243.385-.36l.071-.064c.067-.06.134-.12.2-.178.112-.1.225-.192.339-.285.054-.045.108-.088.163-.131l.154-.12c.105-.082.21-.16.317-.238.055-.042.112-.082.168-.122Z",
    transform: "translate(-149.753 -213.977)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M327.1,248.618v29.514l-3.3-2.3V245.484a15.584,15.584,0,0,1,3.3,3.134Z",
    transform: "translate(-291.755 -213.716)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M122.447,20.7C122.447,9.267,112.085,0,99.3,0S76.159,9.267,76.159,20.7V25.59c0,11.431,10.362,20.7,23.144,20.7s23.144-9.267,23.144-20.7Z",
    transform: "translate(-76.159 0)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M122.447,20.7C122.447,9.267,112.085,0,99.3,0S76.159,9.267,76.159,20.7V25.59c0,11.431,10.362,20.7,23.144,20.7s23.144-9.267,23.144-20.7Z",
    transform: "translate(-76.159 0)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M145.83,8.957a24.76,24.76,0,0,0-38.122,0V37.331a24.76,24.76,0,0,0,38.122,0Z",
    transform: "translate(-103.625 0)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M150.1,42.354a25.388,25.388,0,0,0,27.15,0V3.934a25.388,25.388,0,0,0-27.15,0Z",
    transform: "translate(-140.534 0)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "m",
    d: "M214.368,45.751a26.022,26.022,0,0,0,10.516,0V.537a26.022,26.022,0,0,0-10.516,0Z",
    transform: "translate(-196.482 0)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 23.144,
    cy: 20.697,
    rx: 23.144,
    ry: 20.697,
    transform: "translate(0 0)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "n",
    cx: 20.563,
    cy: 18.389,
    rx: 20.563,
    ry: 18.389,
    transform: "translate(2.581 2.308)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "i",
    cx: 18.615,
    cy: 16.648,
    rx: 18.615,
    ry: 16.648,
    transform: "translate(4.529 4.05)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "o",
    d: "M180.445,62.564l-8.4-8.4a1.028,1.028,0,0,0-.792-.577l-3.909-.569-8.713-8.691h0a1.048,1.048,0,0,0-1.887,0l-3.882,7.989-8.739,1.271a1.05,1.05,0,0,0-.575,1.8l6.193,6.176c.013.018.028.035.043.052l-1.431,8.349a1.035,1.035,0,0,0,.4,1.016l8.488,8.487c.147,0,.295.005.443.005C169.024,79.472,178.454,72.185,180.445,62.564Z",
    transform: "translate(-134.545 -38.077)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M172.1,54.3a1.033,1.033,0,0,0-.848-.717l-8.74-1.271-3.882-7.989a1.048,1.048,0,0,0-1.887,0l-3.882,7.989-8.739,1.271a1.05,1.05,0,0,0-.575,1.8l6.278,5.984-1.473,8.594a1.048,1.048,0,0,0,1.5,1.116l7.833-3.9,7.834,3.9a1.048,1.048,0,0,0,1.5-1.116l-1.473-8.594,6.278-5.984A1.035,1.035,0,0,0,172.1,54.3Zm-14.413,4.571-.013,0,.006-.006.008-.011.008.011.006.006Z",
    transform: "translate(-134.545 -38.076)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "q",
    d: "M157.682,129.969l-.006.006-7.848,2.489-6.278-5.984a1.035,1.035,0,0,1-.273-1.08Z",
    transform: "translate(-134.546 -109.172)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M192.08,160.752l-8.917,12.1a1.034,1.034,0,0,1-.4-1.016l1.473-8.594Z",
    transform: "translate(-168.949 -139.949)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "s",
    d: "M263.93,172.825a1.037,1.037,0,0,1-1.1.1L255,169.02v-8.3l.013,0Z",
    transform: "translate(-231.856 -139.923)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M194.922,160.723v8.3l-7.834,3.9a1.037,1.037,0,0,1-1.1-.1l8.917-12.1Z",
    transform: "translate(-171.778 -139.924)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "u",
    d: "M264.018,172.851l-8.917-12.1,7.849,2.489,1.473,8.594A1.034,1.034,0,0,1,264.018,172.851Z",
    transform: "translate(-231.944 -139.948)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M158.039,116.587l-.008.011-14.405-4.569a1.033,1.033,0,0,1,.848-.717l8.74-1.271Z",
    transform: "translate(-134.895 -95.801)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M259.826,52.316,255,58.862V43.736a1.038,1.038,0,0,1,.943.592Z",
    transform: "translate(-231.856 -38.076)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M222.537,43.736V58.862l-4.826-6.546,3.882-7.989A1.038,1.038,0,0,1,222.537,43.736Z",
    transform: "translate(-199.393 -38.076)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "y",
    d: "M269.413,112.029,255.007,116.6l-.008-.011,4.826-6.546,8.739,1.271A1.033,1.033,0,0,1,269.413,112.029Z",
    transform: "translate(-231.856 -95.801)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "z",
    d: "M269.191,126.482l-6.278,5.984-7.849-2.489-.006-.006,14.405-4.569A1.035,1.035,0,0,1,269.191,126.482Z",
    transform: "translate(-231.907 -109.174)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M186.142,70.479a.858.858,0,0,0-.7-.6l-7.259-1.056-3.225-6.636a.871.871,0,0,0-1.567,0l-3.225,6.636L162.9,69.883a.872.872,0,0,0-.477,1.493l5.215,4.971-1.224,7.138a.871.871,0,0,0,1.247.927l6.507-3.243,6.507,3.243a.871.871,0,0,0,1.247-.927L180.7,76.346l5.215-4.971A.86.86,0,0,0,186.142,70.479Zm-11.972,3.8-.011,0,0,0,.006-.009.006.009,0,0Z",
    transform: "translate(-151.026 -53.715)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "ab",
    cx: 16.642,
    cy: 14.883,
    rx: 16.642,
    ry: 14.883,
    transform: "translate(6.502 5.815)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.cbc9a5b44a76a8ccfc7acf23cb700a7c.svg";
export { ForwardRef as ReactComponent };